import DailyTransactionLog from "../Accounts/DailyTransactionLog";

export default DailyTransactionLog;
